// win_probability is a percentage; a game's rewards together may not exceed 100%.
// The backend rejects such a setup (a total above 100% used to hang the play-game API).
export const MAX_TOTAL_WIN_PROBABILITY = 100;
// Smaller than the smallest stored step (0.00001), so 100.00001 is still rejected
const WIN_PROBABILITY_TOLERANCE = 1e-6;

// A single reward's win_probability may have at most 2 decimal places (e.g. 12.5, 33.33)
export const MAX_WIN_PROBABILITY_DECIMALS = 2;

export const hasTooManyProbabilityDecimals = (value) => {
  if (value === undefined || value === null || value === "") return false;
  const [, decimals = ""] = String(value).trim().split(".");
  return decimals.length > MAX_WIN_PROBABILITY_DECIMALS;
};

// Drops digits beyond 2 decimal places while typing/pasting, e.g. "20.2299" -> "20.22"
export const limitProbabilityDecimals = (value) =>
  hasTooManyProbabilityDecimals(value)
    ? String(value).trim().replace(/(\.\d{2})\d+$/, "$1")
    : value;

/**
 * Returns an error message when the rewards' win_probability values are invalid
 * or total more than 100%, otherwise null. Rewards without a win_probability are skipped.
 */
export const getRewardProbabilityError = (rewards) => {
  if (!Array.isArray(rewards) || rewards.length === 0) return null;

  const probabilities = rewards
    .map((reward) => reward?.win_probability)
    .filter((value) => value !== undefined && value !== null && value !== "")
    .map(Number);

  if (
    probabilities.some(
      (p) => !Number.isFinite(p) || p < 0 || p > MAX_TOTAL_WIN_PROBABILITY
    )
  ) {
    return `Each reward's win probability must be between 0 and ${MAX_TOTAL_WIN_PROBABILITY}%.`;
  }

  const total = probabilities.reduce((sum, p) => sum + p, 0);
  if (total > MAX_TOTAL_WIN_PROBABILITY + WIN_PROBABILITY_TOLERANCE) {
    return `Total win probability of the rewards is ${Number(
      total.toFixed(5)
    )}%. It cannot exceed ${MAX_TOTAL_WIN_PROBABILITY}%.`;
  }
  return null;
};
